module.exports = __webpack_public_path__ + "img/LogoDashboard-2.25338f8a.svg";